module.exports = __webpack_public_path__ + "a7984136dd1a9403b33cf72fcb8a4d53.svg";